export const STYLE_SPACE_TYPE_COMMON = 'COMMON';

export const STYLE_SPACE_TYPE_ENTRANCE = 'ENTRANCE';

export const STYLE_SPACE_TYPE_LIVING_ROOM = 'LIVING_ROOM';

export const STYLE_SPACE_TYPE_KITCHEN = 'KITCHEN';

export const STYLE_SPACE_TYPE_BATH = 'BATH';

export const STYLE_SPACE_TYPE_ROOM = 'ROOM';

export const STYLE_SELECT_DEFAULT_MAX = 1;

export const SLOT_DEFAULT_TYPE = [
  {
    name: '거실',
    type: 'LIVING_ROOM',
  },
  {
    name: '부엌',
    type: 'KITCHEN',
  },
  {
    name: '현관',
    type: 'ENTRANCE',
  },
  {
    name: '욕실',
    type: 'BATH',
  },
  {
    name: '방',
    type: 'ROOM',
  },
];
